<template>
    <div class="sidebar__content">
        <h3 class="h2">{{ product.title }}</h3>

        <ul class="sidebar__specs">
            <li>
                <div class="label-text">
                    Locatie activiteit
                </div>
    
                <div class="sidebar__logo-text">
                    <div>
                        {{ product.location.name }} - {{ product.location.street }} {{ product.location.house_number }},
                        {{ product.location.postal_code }} {{ product.location.city }}
                    </div>

                    <figure>
                        <img
                            v-if="product.location.images.thumbnail"
                            :src="product.location.images.thumbnail"
                            :alt="product.location.name">
                    </figure>
                </div>
            </li>
            <li v-if="product.website">
                <div class="label-text">
                    bekijk openingstijden
                </div>

                <a
                    :href="product.website | external_link"
                    target="_blank">
                    {{ product.website }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
import OpeningHours from './../OpeningHours.vue';

export default {
    props: {
        product: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    components: {
        OpeningHours,
    },
    data() {
        return {
            selectedDate: "0",
        }
    },
    computed: {
        currentActivity() {
            if(this.product.events.length === 0) {
                return null;
            } else {
                return this.product.events[this.selectedDate];
            }
        },
    }
};
</script>
